declare global {
  interface Window {
    APP_API_URL: string;
    APP_ENVIRONMENT: string;
    APP_SENTRY_DSN: string;
  }
}

export const API_URL = process.env.REACT_APP_API_URL;
export const ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT;
export const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN;
